import { Context, use } from 'react'

import { isNil } from 'lodash'
import { StoreApi, useStore } from 'zustand'
import { useShallow } from 'zustand/shallow'

const ZUSTAND_ERROR_MESSAGE =
  'Seems like you have not used zustand provider as an ancestor'

export const assert = <T>(store: T) => {
  if (isNil(store)) {
    throw new Error(ZUSTAND_ERROR_MESSAGE)
  }
  return store as Exclude<T, undefined | null>
}

const useExplicitStore = <T>(context: Context<T>) => {
  const store = use(context)
  return assert(store)
}

export const useContextStore = <T, StateSlice>(
  context: Context<StoreApi<T> | undefined>,
  selector: (state: T) => StateSlice
) => {
  const store = useExplicitStore(context) as StoreApi<T>
  return useShallowStore<T, StateSlice>(store, selector)
}

export const useContextStoreApi = <T>(
  context: Context<StoreApi<T> | undefined>
) => {
  const store = useExplicitStore(context)
  return store
}

export const useShallowStore = <T, StateSlice>(
  store: StoreApi<T>,
  selector: (state: T) => StateSlice
) => {
  return useStore<StoreApi<T>, StateSlice>(store, useShallow(selector))
}
